import React from "react";
import { useEffect, useState } from "react";

const useEmpListAssignLeaves = (empArr, handleSelectedEmp,IsAllSelected,selectedEmp,mappedEmployeeList) => {
  const [trow, setTrow] = useState([]);
  const [empr, setempr] = useState([]);


  useEffect(() => {
    let trow =empArr && empArr.map((emp, i) => {

       return {
       
        //  id: <div>{emp[i].employeeId}</div>,
         Select : <div><input type="checkBox" checked={IsAllSelected ||
           (mappedEmployeeList.some(element => { if (element.employeeId === emp.employeeId){
          if(element.ismapped == 1) {
            return true;
          }
          else
          {
            return false;
          }
         } })) ||
         (selectedEmp.some(element => { if (element.employeeId === emp.employeeId) {
          return true;
        }else{return false} }))==true ?true:false }  onClick={(e) => handleSelectedEmp(emp,e)}></input></div>,
         Name: (
           <h2
           className="table-avatar"
            
           >
             {/* <img
               className="profile-img-table"
               alt=""
               src={require(`../../../img/employee/${emp.profilePicture == null || emp.profilePicture == "null" || emp.profilePicture == 'undefined'? 'user.png' :("https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/"+ emp.profilePicture)}`)}
             /> */}
             <span className="ml-2">
               <span style={{ fontWeight: "400", color: "black" }}>
                 {emp.employeeName}
               </span>
               {/* <span> {employee[i].designationName}</span> */}
             </span>
           </h2>
         ),
        //  project: (
        //    employee[i].projectList.filter( (ele, ind) => ind === employee[i].projectList.findIndex( elem => elem.projectID === ele.projectID)).map(
        //      (member, i) => (
        //        <span key={member.projectID}>
        //        <small>{member.projectName},</small>
  
        //      </span>  
        //      )
        //    )
                
        
        //   ),
       };
    //  })  
    })
    setTrow(trow);
  }, [empArr, handleSelectedEmp]);

  return { trow };
};

export default useEmpListAssignLeaves;

// <table cellspacing="0" cellpadding="0" border="0" width="325">
//       <tr>
//         <td>
//           <Table hover style={{ margin: "0px" }} {...getTableProps()} striped className="mt-2">
//             <thead>
//   {headerGroups.map((headerGroup, p) => (
//     <tr key={p} {...headerGroup.getHeaderGroupProps()}>
//       {headerGroup.headers.map((column) => (
//         <th {...column.getHeaderProps(column.getSortByToggleProps())}>
//           {column.render("Header")}
//           {/* Add a sort direction indicator */}
//           <span className="">
//             <i className="fas fa-exchange-alt fa-rotate-90 ml-3"></i>
//             {/* {column.isSorted ? (
//               column.isSortedDesc ? (
//                 " 🔽"
//               ) : (
//                 " 🔼"
//               )
//             ) : (
//               <i className="fas fa-exchange-alt fa-rotate-90"></i>
//             )} */}
//           </span>
//         </th>
//       ))}
//     </tr>
//   ))}
// </thead>
//           </Table>
//         </td>
//       </tr>
//       <tr>
//         <td>
//           <div style={{ width: "500px", height: "180px", overflow: "auto" }}>
//             <Table hover>
// <tbody {...getTableBodyProps()}>
// {page.map((row, i) => {
//   prepareRow(row);
//   return (
//     <tr key={i} {...row.getRowProps()}>
//       {row.cells.map((cell, k) => {
//         return (
//           <td key={k} {...cell.getCellProps()}>
//             {cell.render("Cell")}
//           </td>
//         );
//       })}
//     </tr>
//   );
// })}
// </tbody>
//             </Table>
//            </div>
//          </td>
//        </tr>
//      </table>
